


































































import { CreateClientRequest } from '@/api/requests/clients/create-client-request';
import { ClientTitleType } from '@/shared/types/client-title-type';
import { DateTime } from 'luxon';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');

@Component
export default class AddClientDetails extends Vue {
    @typesModule.Getter('activeClientTitleTypes') private clientTitleTypes!: Array<ClientTitleType>;

    @Prop({ required: true }) private client!: CreateClientRequest;

    private endDate: Date = DateTime.local().minus({ years: 18 }).toJSDate();

    private get validDateOfBirth(): string {
        const validDate = DateTime.fromJSDate(this.endDate).plus({ days: 1 }).toFormat('dd/MM/yyyy');
        return `${validDate}`;
    }
}
